import diCacheConfigAPI from '@/apis/di/diCacheConfigAPI.js';

const state = {
  items: null,
};
let getters = {};

for (let i in state) {
  getters[i] = function (a) {
    return a[i];
  };
}
const actions = {
  getCacheConfig: async function (context) {
    const cacheConfig = await diCacheConfigAPI.getAllAsync();
    context.commit('setItems', cacheConfig);
    return cacheConfig;
  },
};
const mutations = {
  setItems(state, data) {
    state.items = data;
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
